
import WalletRemove from "../../../assets/outline/WalletRemove.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function WalletRemoveIcon({ className, dataTestid = "WalletRemoveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <WalletRemove data-testid={dataTestid} className={classes} {...rest} />
  );
}
